import { render, staticRenderFns } from "./03-vod.vue?vue&type=template&id=128fbf62"
import script from "./03-vod.vue?vue&type=script&lang=ts"
export * from "./03-vod.vue?vue&type=script&lang=ts"
import style0 from "./03-vod.vue?vue&type=style&index=0&id=128fbf62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports